import React from 'react';
import { useGlobalContext, TripType, parseBoolean, useSearch } from '@honeycomb/data';
import { TypographyHeading, TypographyBody, Skeleton2, UnsafeHTML } from '@honeycomb/ui-core';
import { interjectResourceString } from '../../../utils/interjectResourceString';
import { pluraliseCount } from '../../../utils/pluraliseCount';
export function HotelSearchResultsHeading({ sponsoredHotelMessage, filteredHotelCount, loading = false, }) {
    const { resourceStrings: { HOTELS_SRP_TITLE, HOTELS_SRP_TITLE_SINGULAR, HOTELS_SRP_TITLE_LOADING, HOLIDAY_HOTELS_SRP_TITLE, HOLIDAY_HOTELS_SRP_TITLE_SINGULAR, HOLIDAY_HOTELS_SRP_TITLE_LOADING, }, configSettings: { HCHideSponsoredHotelMessage }, } = useGlobalContext();
    const [{ tripType }] = useSearch([]);
    const isHoliday = tripType === TripType.Holiday;
    const getTitle = () => {
        const title = isHoliday ? HOLIDAY_HOTELS_SRP_TITLE : HOTELS_SRP_TITLE;
        const titleSingular = isHoliday ? HOLIDAY_HOTELS_SRP_TITLE_SINGULAR : HOTELS_SRP_TITLE_SINGULAR;
        const titleLoading = isHoliday ? HOLIDAY_HOTELS_SRP_TITLE_LOADING : HOTELS_SRP_TITLE_LOADING;
        if (loading) {
            return titleLoading;
        }
        return pluraliseCount(filteredHotelCount, {
            singular: titleSingular,
            plural: interjectResourceString(title, filteredHotelCount),
        });
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(TypographyHeading, { component: "h1", weight: "bold" }, getTitle()),
        !parseBoolean(HCHideSponsoredHotelMessage) && sponsoredHotelMessage && (React.createElement(TypographyBody, { component: "div", size: "s", mt: 2 }, loading ? React.createElement(Skeleton2, { variant: "text", w: 320 }) : React.createElement(UnsafeHTML, null, sponsoredHotelMessage)))));
}
